"use strict";

var caches = {
    __data: Object.create(null),

    set: function set(key, val) {
        this.__data[key] = val;
    },

    get: function get(key) {
        return this.__data[key];
    },

    reset: function reset() {
        this.__data = {};
    }
};

module.exports = caches;